import { COUNTRY_CODES } from "./countries";

const IDENTITY_DOCUMENTS = {
  [COUNTRY_CODES.ECUADOR]: {
    cedula: {
      label: "Cédula",
      value: "Cedula",
      aliases: ["ID"], // BC (SaaS Ecuador) devuelve "ID" en Tipo_Documento_SrI para clientes con cédula (verificado contra ListaClientes)
      regex: /^\d{10}$/,
      message: "La cédula debe tener exactamente 10 dígitos numéricos",
    },
    ruc: {
      label: "RUC",
      value: "RUC",
      aliases: ["VAT"], // BC (SaaS Ecuador) devuelve "VAT" en Tipo_Documento_SrI para clientes con RUC (verificado contra ListaClientes)
      regex: /^\d{13}$/,
      message: "El RUC debe tener exactamente 13 dígitos numéricos",
    },
    pasaporte: {
      label: "Pasaporte",
      value: "Pasaporte",
      aliases: ["Passport"], // BC (SaaS Ecuador) devuelve "Passport" en Tipo_Documento_SrI para clientes con pasaporte (verificado contra ListaClientes)
      regex: /^[A-Za-z0-9]{6,20}$/,
      message: "El pasaporte debe ser alfanumérico entre 6 y 20 caracteres",
    },
  },
  [COUNTRY_CODES.PARAGUAY]: {
    cedula: {
      label: "Cédula",
      value: "Cedula",
      regex: /^[A-Za-z0-9-]{6,20}$/,
      message: "El documento debe tener entre 6 y 20 cáracteres",
    },
    ruc: {
      label: "RUC",
      value: "RUC",
      regex: /^[A-Za-z0-9\-]{8,20}$/,
      message: "El documento debe tener entre 8 y 20 cáracteres",
    },
    pasaporte: {
      label: "Pasaporte",
      value: "Pasaporte",
      regex: /^[A-Za-z0-9-]{9,20}$/,
      message: "El documento debe tener entre 9 y 20 cáracteres",
    },
  },
  [COUNTRY_CODES.ELSALVADOR]: {
    nit: {
      label: "NIT",
      value: "NIT",
      regex: /^\d{4}-?\d{6}-?\d{3}-?\d$/,
      message: "El NIT debe tener 14 dígitos (con o sin guiones)",
    },
    dui: {
      label: "DUI",
      value: "DUI",
      regex: /^\d{8}-?\d$/,
      message: "El DUI debe tener 9 dígitos (con o sin guion)",
    },
    otros: {
      label: "Otros",
      value: "Otros",
      regex: /^.{1,20}$/,
      message: "Otros admite entre 1 y 20 caracteres",
    },
    [COUNTRY_CODES.HONDURAS]: {
      rtn: {
        label: "RTN",
        value: "RTN",
        regex: /^\d{14}$/,
        message: "El RTN debe tener exactamente 14 dígitos numéricos",
      },
    },
  },
};

export const findIdentityDocument = (country, selectedType) => {
  const docs = getIdentityDocument(country);

  return Object.values(docs).find(
    doc =>
      doc.value === selectedType ||
      doc.aliases?.includes(selectedType)
  );
};

export const getIdentityDocument = (country) => { return (IDENTITY_DOCUMENTS[country] || IDENTITY_DOCUMENTS[COUNTRY_CODES.ECUADOR]); };
